import { render, staticRenderFns } from "./commdsBrand.vue?vue&type=template&id=21fec023&scoped=true"
import script from "./commdsBrand.vue?vue&type=script&lang=ts"
export * from "./commdsBrand.vue?vue&type=script&lang=ts"
import style0 from "./commdsBrand.vue?vue&type=style&index=0&id=21fec023&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fec023",
  null
  
)

export default component.exports